import { List, ListSubheader, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LegendListItem from './LegendListItem';
import {
  AnimalShelterLocation,
  InfoLocation,
  ShelterLocation,
  FoodLocation,
} from '../Icons';

const LocationsLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <ListSubheader disableSticky>
          <Typography
            variant="h4"
            component="h3"
            color="textPrimary"
            sx={(theme) => ({
              lineHeight: '1.6',
              fontSize: theme.typography.h3.fontSize,
            })}
          >
            {t('map.legends.locations.title')}
          </Typography>
        </ListSubheader>
      }
    >
      <LegendListItem
        iconSrc={ShelterLocation.data}
        primaryText={t('map.legends.locations.legends.evacShelter.title')}
        secondary={t('map.legends.locations.legends.evacShelter.subtitle')}
      />
      <LegendListItem
        iconSrc={AnimalShelterLocation.data}
        primaryText={t('map.legends.locations.legends.animalShelter.title')}
        secondary={t('map.legends.locations.legends.animalShelter.subtitle')}
      />
      <LegendListItem
        iconSrc={InfoLocation.data}
        primaryText={t('map.legends.locations.legends.information.title')}
        secondary={t('map.legends.locations.legends.information.subtitle')}
      />
      <LegendListItem
        iconSrc={FoodLocation.data}
        primaryText={t('map.legends.locations.legends.food.title')}
        secondary={t('map.legends.locations.legends.food.subtitle')}
      />
    </List>
  );
};

export default LocationsLegend;
